export default __webpack_public_path__ + "07d7ce2b0ef0932f90784aa3a7f6c5e2.png";